import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import Backend from "i18next-http-backend"
import LanguageDetector from "i18next-browser-languagedetector"
import config from "config/config"
import { formatNumber } from "utils/utils"

export const i18nInit = i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: config.defaultLanguage,
        backend: {
            loadPath: `/locales/{{lng}}.json${config.buildId ? `?v=${config.buildId}` : ""}`
        },
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        react: {
            useSuspense: false
        },
        returnNull: false,
    })

// interpolation.format was removed in i18next 26; named formatters replace it
i18n.services.formatter?.add("number", (value, lng) =>
    typeof value === "number" ? formatNumber(value, 0, undefined, lng) : value)
i18n.services.formatter?.add("money", (value, lng) => {
    if (typeof value === "number") return formatNumber(value, 2, 2, lng)
    if (typeof value === "undefined") return "–"
    return value
})

i18n.on('languageChanged', (lng) => (document.documentElement.lang = lng))

export default i18n
